// TODO サポート側と統一
const constants = {
  service: {
    設計: 1,
    製造: 2,
    実装: 3,
  },
  serviceDetail: {
    リジッド: 1,
    フレキ: 2,
    メタル: 3,
  },
} as const

export default constants
